import * as commonScripts from '../common'
const cmpHeadlineLogos = {
  component: null,
  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    const imageHover = _.component.getElementsByClassName('image-hover')
    const imageIn = _.component.getElementsByClassName('image-in')
    for (let i = 0; i < imageHover.length; i++) {
      imageHover[i].addEventListener('mouseover', function () {
        imageIn[i].style.opacity = 0
      }, false)
      imageHover[i].addEventListener('mouseout', function () {
        imageIn[i].style.opacity = 1
      }, false)
    }
  }
}
export default cmpHeadlineLogos
